"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const use_debounce_1 = require("use-debounce");
const react_2 = require("@ag-grid-community/react");
const react_toastify_1 = require("react-toastify");
const js_1 = __importDefault(require("@bugsnag/js"));
const client_side_row_model_1 = require("@ag-grid-community/client-side-row-model");
const range_selection_1 = require("@ag-grid-enterprise/range-selection");
const clipboard_1 = require("@ag-grid-enterprise/clipboard");
const side_bar_1 = require("@ag-grid-enterprise/side-bar");
const column_tool_panel_1 = require("@ag-grid-enterprise/column-tool-panel");
const filter_tool_panel_1 = require("@ag-grid-enterprise/filter-tool-panel");
const rich_select_1 = require("@ag-grid-enterprise/rich-select");
const status_bar_1 = require("@ag-grid-enterprise/status-bar");
const menu_1 = require("@ag-grid-enterprise/menu");
const excel_export_1 = require("@ag-grid-enterprise/excel-export");
require("@ag-grid-community/core/dist/styles/ag-grid.css");
require("@ag-grid-community/core/dist/styles/ag-theme-balham.css");
const api_1 = require("../../api");
const ViewsToolPanelComponent_1 = __importDefault(require("../ToolPanels/ViewsToolPanelComponent"));
const errorNotification_1 = require("../../errorNotification");
const NewColumnToolPanelComponent_1 = __importDefault(require("../ToolPanels/NewColumnToolPanelComponent"));
const use_pusher_1 = require("@harelpls/use-pusher");
const utils_1 = require("../utils");
const GridColumnTypes_1 = __importDefault(require("../Common/GridColumnTypes"));
const NumericEditorReact_1 = __importDefault(require("../Editors/NumericEditorReact"));
const StatusBarComponent_1 = __importDefault(require("../StatusBarComponent"));
const PlantOptionsColumns_1 = require("./PlantOptionsColumns");
const AuthContext_1 = require("../../Auth/AuthContext");
const quickOrderedFilter_1 = require("../quickOrderedFilter");
const gridUtils_1 = require("../gridUtils");
const Button_1 = __importDefault(require("../../forms/Button"));
const Modal_1 = __importDefault(require("../Modal"));
const NewQualityForm_1 = __importDefault(require("../../forms/NewQualityForm"));
const gridLocale_de_1 = __importDefault(require("../gridLocale.de"));
const DuplicateTextCellEditor_1 = require("../Editors/DuplicateTextCellEditor");
const utils_2 = require("../../Auth/utils");
const IsAllowed_1 = __importDefault(require("../../Auth/IsAllowed"));
const enums_1 = require("../../types/enums");
const LabelConfirmationGridEditor_1 = __importDefault(require("../Editors/LabelConfirmationGridEditor"));
const master_detail_1 = require("@ag-grid-enterprise/master-detail");
const DetailPicturesCellRenderer_1 = __importDefault(require("../Renderers/DetailPicturesCellRenderer"));
const ToastErrorContent_1 = __importDefault(require("../ToastErrorContent"));
const permissions_1 = require("../../types/permissions");
const pusherEvents_1 = require("../Common/pusherEvents");
var quickFilterParsedValue = [];
const PlantOptionsGrid = () => {
    const [gridClientID,] = (0, react_1.useState)((0, pusherEvents_1.generateGridClientId)('plantQualities'));
    const [qualityGridApi, setQualityGridApi] = (0, react_1.useState)(null);
    const [, setGridColumnApi] = (0, react_1.useState)(null);
    const [rows] = (0, react_1.useState)([]);
    const [columns, setColumns] = (0, react_1.useState)([]);
    const [newItemModalOpened, setNewItemModalOpened] = (0, react_1.useState)(false);
    const [isUserEditingGrid, setIsUserEditingGrid] = (0, react_1.useState)(false);
    const [remoteTransactionsQueue, setRemoteTransactionsQueue] = (0, react_1.useState)([]);
    const [quickFilterText, setQuickFilterText] = (0, react_1.useState)('');
    const [debouncedQuickFilterText] = (0, use_debounce_1.useDebounce)(quickFilterText, 300);
    const api = new api_1.PlantOptionApi(undefined, gridClientID);
    const channelName = 'presence-plant-options';
    const eventName = 'qualities.changed';
    const { user } = (0, AuthContext_1.useAuth)();
    const channel = (0, use_pusher_1.useChannel)(channelName);
    // server push, used to update records by updates from quality table
    const createGridTransaction = (data, metadata) => {
        // checking grid client ID to avoid applying updates from the same client grid
        if (data.gridClientId === gridClientID) {
            return null;
        }
        // if the update is from the same user dont do anything
        const itemsToAdd = data.add;
        // map changes to updatable grid nodes, update only fields that changed to avoid conflicts
        const itemsToUpdate = data.update.map(change => {
            const rowNode = qualityGridApi.getRowNode(String(change.id));
            return { ...rowNode.data, ...change.attributes };
        });
        const itemsToRemove = data.remove.map(r => {
            return qualityGridApi.getRowNode(String(r));
        });
        return {
            add: itemsToAdd,
            update: itemsToUpdate,
            remove: itemsToRemove
        };
    };
    // server push, used to update records by updates from plants table
    const createGridTransactionForPlantUpdate = (data, metadata) => {
        const updates = data.update.reduce((ups, record) => {
            return [...ups, ...record.qualities.map(id => {
                    const rowNode = qualityGridApi.getRowNode(String(id));
                    const atts = Object.keys(record.attributes).reduce((acc, key) => {
                        // Use the keyMapping to get the new key, or use the old key if not mapped
                        const newKey = key + '@plants';
                        acc[newKey] = record.attributes[key];
                        return acc;
                    }, {});
                    return { id: id, ...rowNode.data, ...atts };
                })];
        }, []);
        return {
            add: [],
            update: updates,
            remove: [],
        };
    };
    (0, use_pusher_1.useEvent)(channel, eventName, (0, pusherEvents_1.proccessPusherEvents)(user, createGridTransaction, qualityGridApi, isUserEditingGrid, { queue: remoteTransactionsQueue, setQueue: setRemoteTransactionsQueue }));
    (0, use_pusher_1.useEvent)((0, use_pusher_1.useChannel)('presence-plants'), 'plants.changed', (0, pusherEvents_1.proccessPusherEvents)(user, createGridTransactionForPlantUpdate, qualityGridApi, isUserEditingGrid, { queue: remoteTransactionsQueue, setQueue: setRemoteTransactionsQueue }));
    (0, react_1.useEffect)(() => {
        if (!isUserEditingGrid) {
            (0, pusherEvents_1.applyGridTransactions)(qualityGridApi, [...remoteTransactionsQueue]);
            setRemoteTransactionsQueue(() => []);
        }
    }, [isUserEditingGrid]);
    (0, react_1.useEffect)(() => {
        quickFilterParsedValue = debouncedQuickFilterText ? debouncedQuickFilterText.toString().toLowerCase().split(' ') : [];
        if (qualityGridApi)
            qualityGridApi.onFilterChanged();
    }, [debouncedQuickFilterText]);
    const sideBarDef = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressSideButtons: false,
                    suppressColumnExpandAll: true,
                },
            },
            // 'filters',
            {
                id: 'views',
                labelDefault: 'Views',
                labelKey: 'views',
                iconKey: 'eye',
                toolPanel: 'viewsToolPanel',
                toolPanelParams: {
                    gridModel: 'plant_option',
                }
            },
        ],
        defaultToolPanel: 'columns',
    };
    const gridModules = [
        range_selection_1.RangeSelectionModule,
        client_side_row_model_1.ClientSideRowModelModule,
        clipboard_1.ClipboardModule,
        side_bar_1.SideBarModule,
        column_tool_panel_1.ColumnsToolPanelModule,
        filter_tool_panel_1.FiltersToolPanelModule,
        master_detail_1.MasterDetailModule,
        rich_select_1.RichSelectModule,
        status_bar_1.StatusBarModule,
        menu_1.MenuModule,
        excel_export_1.ExcelExportModule,
    ];
    function onGridReady(params) {
        setQualityGridApi(params.api);
        setGridColumnApi(params.columnApi);
        const fetchData = async () => {
            params.api.showLoadingOverlay();
            try {
                const data = await api.index();
                const columnsDefitions = (0, PlantOptionsColumns_1.createQualityColumn)(data.columns, data.presets);
                params.api.setColumnDefs(columnsDefitions);
                setColumns(columnsDefitions);
                params.api.setRowData(data.records);
            }
            catch (e) {
                if (e.response.status === 403) {
                    (0, errorNotification_1.notifyError)(e.response.data.message);
                }
                else {
                    (0, errorNotification_1.notifyError)(e.message);
                }
            }
            params.api.hideOverlay();
        };
        fetchData().then(() => { });
    }
    const onFirstDataRendered = (event) => {
        event.columnApi.autoSizeAllColumns(true);
    };
    const defaultColDef = {
        flex: 1,
        minWidth: 75,
        filter: true,
        editable: (params) => {
            // check if user is allowed to update
            if (!(0, utils_2.isAllowed)(user, ['update_plant_option'])) {
                return false;
            }
            if ((0, gridUtils_1.isGridColumnOfType)(params.column, 'perCompanyColumn')) {
                // admin can edit all company fields
                if ((0, utils_2.hasRole)(user, ['admin'])) {
                    return true;
                }
                //if not admin, check user's company
                return (0, utils_2.fieldContainsCompany)(params.column.getColId(), user?.company_short);
            }
            // check if user is allowed to update columns for label confirmed ("Überprüft") options
            if ((0, gridUtils_1.isGridColumnOfType)(params.column, 'perm_editConfirmedLabel')) {
                // restricted plant columns updating through PlantOptions Gridtable if it has label confirmed options
                if (params.data.plant_label_confirmed && (0, gridUtils_1.isGridColumnFromCrossTable)(params.column, 'plants')) {
                    return (0, utils_2.isAllowed)(user, [permissions_1.GridPermissions.EDIT_CONFIRMED_LABEL]);
                }
                // restricted label confirmed record editing
                if (params.data.label_confirmed) {
                    return (0, utils_2.isAllowed)(user, [permissions_1.GridPermissions.EDIT_CONFIRMED_LABEL]);
                }
            }
            return (0, utils_2.isAllowed)(user, ['update_plant_option']);
        },
        resizable: true,
        sortable: true,
        floatingFilter: true,
        enablePivot: false,
        enableValue: false,
        enableRowGroup: false,
        cellClass: 'default',
    };
    const updatePlants = async (updates, apiG) => {
        const apiGrid = apiG || qualityGridApi;
        try {
            const { success, changes } = await api.bulkUpdate({ updates });
            const update = changes.map(change => {
                const rowNode = apiGrid.getRowNode(change.id);
                const a = updates.find(o => o.id === change.id);
                // nasty hack so rowNode.setDataValue(column, value) doesnt trigger update on cellValueChangedEvent
                rowNode.internalUpdate = true;
                const isTheSameColumn = (id, column) => {
                    const a = updates.find(o => o.id === change.id);
                    if (a) {
                        a.column == column;
                    }
                    return false;
                };
                for (const [column, value] of Object.entries(change.attributes)) {
                    if (!isTheSameColumn(change.id, column) && apiGrid.getColumnDef(column) !== null) {
                        rowNode.setDataValue(column, value);
                    }
                }
                rowNode.internalUpdate = false;
            });
        }
        catch (error) {
            if (error.response && error.response.status > 200) {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            else {
                (0, errorNotification_1.notifyError)(error.message);
            }
        }
    };
    const debouncedUpdate = (0, utils_1.debounceAgg)(updatePlants, 250);
    const doesExternalFilterPass = (node) => {
        return (0, quickOrderedFilter_1.quickOrderedFilter)((node.data['botanisch_slugged'] || '').split("-"), quickFilterParsedValue);
    };
    const isExternalFilterPresent = () => {
        return quickFilterParsedValue.length > 0;
    };
    const gridOptions = {
        enableRangeSelection: true,
        tooltipShowDelay: 1,
        getRowNodeId: (data) => {
            return data.id;
        },
        isExternalFilterPresent: isExternalFilterPresent,
        doesExternalFilterPass: doesExternalFilterPass,
        detailCellRenderer: 'DetailPicturesCellRenderer',
        detailCellRendererParams: { plantIdColumn: 'plant_id' },
        excelStyles: [
            {
                id: 'default',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'derived',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'header',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
            {
                id: 'booleanType',
                dataType: 'Boolean',
                font: {
                    fontName: 'Arial',
                    size: 10,
                }
            },
        ],
    };
    const statusBar = {
        statusPanels: [
            {
                statusPanel: 'StatusBarComponent',
                statusPanelParams: {
                    channelName: channelName,
                },
            },
        ],
    };
    const cellValueChanged = async (event) => {
        const { data } = event;
        // internalUpdate to ignore events triggered by server updates and prevent cycled updating, mainly by @plants fields
        // @ts-ignore
        if (event.node.internalUpdate) {
            return;
        }
        const { newValue = null, oldValue = null } = event;
        if (newValue === oldValue) {
            return;
        }
        const isEditable = event.column.isCellEditable(event.node);
        if (isEditable) {
            const column = event.column.getColId();
            const { id } = data;
            try {
                debouncedUpdate({ id, column, value: newValue });
            }
            catch (e) {
                (0, errorNotification_1.notifyError)(e.message);
            }
        }
    };
    const duplicateRecord = async (gridApi) => {
        const rows = gridApi.getSelectedNodes();
        if (rows.length === 0) {
            (0, errorNotification_1.notify)('error', 'Keine Datensätze zur Vervielfältigung ausgewählt!');
            return;
        }
        if (rows.length > 1) {
            (0, errorNotification_1.notify)('error', 'Wählen Sie nur 1 Datensatz zum Duplizieren aus!');
            return;
        }
        try {
            const [rowToDuplicate] = rows;
            const { success, record } = await api.duplicate(rowToDuplicate.data.id);
            if (success) {
                const transaction = gridApi.applyTransaction({ addIndex: rowToDuplicate.rowIndex + 1, add: [record] });
                (0, errorNotification_1.notify)('success', 'Zeile dupliziert.');
                const [addedRow] = transaction.add;
                gridApi.flashCells({ rowNodes: [addedRow] });
            }
        }
        catch (error) {
            if (error.response && error.response.status > 200) {
                (0, errorNotification_1.notifyError)(error.response.data.message);
            }
            else {
                (0, errorNotification_1.notifyError)(error.message);
            }
        }
    };
    const deleteRecords = async (gridApi) => {
        const rows = gridApi.getSelectedNodes();
        if (rows.length === 0) {
            (0, errorNotification_1.notify)('error', 'Keine Datensätze zu Löschen ausgewählt!');
            return;
        }
        const ids = rows.map(row => row.data.id).join(', ');
        if (confirm(`Möchten Sie diese Datensatz-ID wirklich löschen: ${ids}?`)) {
            try {
                const { success } = await api.delete(rows.map((row) => row.id));
                if (success)
                    gridApi.applyTransaction({ remove: rows });
            }
            catch (error) {
                if (error.response && error.response.status > 200) {
                    (0, errorNotification_1.notifyError)(error.response.data.message);
                }
                else {
                    (0, errorNotification_1.notifyError)(error.message);
                }
            }
        }
    };
    const getContextMenuItems = (params) => {
        return [
            (0, utils_2.isAllowed)(user, ['update_plant_option']) ? {
                name: 'Wert "' + params.value + '" für markierte Zeilen übernehmen',
                action: function () {
                    const rows = params.api.getSelectedNodes();
                    rows.forEach(row => {
                        if (!params.column.isCellEditable(row)) {
                            return;
                        }
                        row.setDataValue(params.column, params.value);
                    });
                },
            } : '',
            'copy',
            (0, utils_2.isAllowed)(user, ['update_plant_option']) ? {
                name: 'Auf überprüft setzen',
                action: function () {
                    const rows = params.api.getSelectedNodes();
                    rows.forEach((row) => {
                        row.setDataValue('checked', true);
                    });
                },
            } : '',
            (0, utils_2.isAllowed)(user, ['create_plant_option', 'delete_plant_option']) ? 'separator' : '',
            (0, utils_2.isAllowed)(user, ['create_plant_option']) ? {
                name: 'Zeile duplizieren',
                action: function () {
                    duplicateRecord(params.api);
                }
            } : '',
            (0, utils_2.isAllowed)(user, ['delete_plant_option']) ? {
                name: 'Zeilen löschen',
                action: function () {
                    deleteRecords(params.api);
                },
            } : '',
        ];
    };
    const handleExcelExport = async () => {
        const params = {
            fileName: 'Qualitäten_export',
            sheetName: 'Sheet1',
            onlySelected: true,
        };
        qualityGridApi.exportDataAsExcel(params);
    };
    const exportFloramedia = () => {
        location.assign(`/api/export/floramedia`);
    };
    const exportFloramediaPictures = async () => {
        try {
            const resp = await api.validateFloramediaPictureExport();
            if (resp.status === 'error') {
                const ExportError = react_1.default.createElement(ToastErrorContent_1.default, { title: resp.title },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: 'mt-1 text-sm' }, resp.text),
                        react_1.default.createElement("div", { className: 'mt-3' },
                            react_1.default.createElement(Button_1.default, { onClick: () => location.assign(`/api/export/floramedia-pictures-stream`) }, "Exportieren"))));
                react_toastify_1.toast.error(ExportError, { autoClose: false });
            }
            if (resp.status === 'ok') {
                location.assign(`/api/export/floramedia-pictures-stream`);
            }
        }
        catch (error) {
            js_1.default.notify(error);
        }
    };
    const exportCatalog = () => {
        // if (confirm('Wollen Sie alle überprüften Datensätze für Floramedia exportieren?')) {
        location.assign(`/api/catalogs/export`);
        // }
    };
    const resetFilters = () => {
        qualityGridApi.setFilterModel(null);
        setQuickFilterText('');
        qualityGridApi.onFilterChanged();
    };
    const cellEditingStarted = (e) => {
        setIsUserEditingGrid(true);
    };
    const cellEditingStopped = (e) => {
        setIsUserEditingGrid(false);
    };
    const handleNewQuality = (record) => {
        const transaction = qualityGridApi.applyTransaction({ addIndex: 0, add: [record] });
        const [addedRow] = transaction.add;
        qualityGridApi.ensureNodeVisible(addedRow, 'top');
        qualityGridApi.flashCells({ rowNodes: [addedRow] });
        setNewItemModalOpened(false);
    };
    const getRowClassRules = {
        'complete': (params) => params.data.label_state === enums_1.LABELSTATES.COMPLETE,
        'checked': (params) => params.data.label_state === enums_1.LABELSTATES.VERIFIED,
        'exported': (params) => params.data.label_state === enums_1.LABELSTATES.EXPORTED,
    };
    const gridTable = (0, react_1.useMemo)(() => {
        return (react_1.default.createElement(react_2.AgGridReact
        // @ts-ignore
        , { 
            // @ts-ignore
            modules: gridModules, localeText: gridLocale_de_1.default, disableStaticMarkup: true, onGridReady: onGridReady, onFirstDataRendered: onFirstDataRendered, onCellKeyDown: gridUtils_1.onCellKeyDown, onCellEditingStarted: cellEditingStarted, onCellEditingStopped: cellEditingStopped, rowSelection: 'multiple', suppressCopyRowsToClipboard: true, enableRangeSelection: true, undoRedoCellEditing: true, enableCellChangeFlash: true, animateRows: true, enableFillHandle: true, fillHandleDirection: 'y', gridOptions: gridOptions, columnDefs: columns, defaultColDef: defaultColDef, columnTypes: GridColumnTypes_1.default, rowData: rows, sideBar: sideBarDef, getRowNodeId: (data) => data.id, getContextMenuItems: getContextMenuItems, onCellValueChanged: cellValueChanged, rowClassRules: getRowClassRules, masterDetail: true, frameworkComponents: {
                viewsToolPanel: ViewsToolPanelComponent_1.default,
                newColumnToolPanel: NewColumnToolPanelComponent_1.default,
                StatusBarComponent: StatusBarComponent_1.default,
                NumericEditor: NumericEditorReact_1.default,
                LabelConfirmationGridEditor: LabelConfirmationGridEditor_1.default,
                DetailPicturesCellRenderer: DetailPicturesCellRenderer_1.default,
            }, components: {
                DuplicateTextCellEditor: DuplicateTextCellEditor_1.DuplicateTextCellEditor,
            }, suppressLastEmptyLineOnPaste: true, statusBar: statusBar }));
    }, [rows, columns, qualityGridApi]);
    return (react_1.default.createElement("div", { id: 'plant-options-grid', className: "zas-theme zas-grid ag-theme-balham flex flex-col w-full" },
        react_1.default.createElement("div", { className: 'mb-2 flex items-end space-x-4' },
            react_1.default.createElement("div", { className: 'max-w-lg' },
                react_1.default.createElement("input", { type: "text", id: "filter-text-box", className: 'form-input', placeholder: "Suche...", value: quickFilterText, onChange: e => setQuickFilterText(e.target.value) })),
            react_1.default.createElement("div", { className: 'space-x-2 flex flex-1' },
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['create_plant_option'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => setNewItemModalOpened(true) }, "Neue Qualit\u00E4t")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['delete_plant_option'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => deleteRecords(qualityGridApi) }, "Zeilen l\u00F6schen")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['create_plant_option'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => duplicateRecord(qualityGridApi) }, "Zeile duplizieren")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: ['export_excel'] },
                    react_1.default.createElement(Button_1.default, { onClick: () => handleExcelExport(), title: "" }, "Excel-Export")),
                react_1.default.createElement(IsAllowed_1.default, { permissions: [permissions_1.ExportsPermissions.EXPORT_FLORAMEDIA] },
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(Button_1.default, { onClick: () => exportFloramedia(), title: "" }, "FM Export"),
                        react_1.default.createElement(Button_1.default, { onClick: () => exportFloramediaPictures(), title: "" }, "FM Bilder Export")))),
            react_1.default.createElement("div", { className: 'space-x-1' },
                react_1.default.createElement(Button_1.default, { onClick: () => resetFilters(), size: 'sm', variant: 'white' }, "Filter zur\u00FCcksetzen"),
                react_1.default.createElement(Button_1.default, { onClick: () => qualityGridApi.undoCellEditing(), size: 'sm', variant: 'white' }, "Undo"),
                react_1.default.createElement(Button_1.default, { onClick: () => qualityGridApi.redoCellEditing(), size: 'sm', variant: 'white' }, "Redo"))),
        gridTable,
        react_1.default.createElement(Modal_1.default, { isOpen: newItemModalOpened, onRequestClose: () => { setNewItemModalOpened(false); } },
            react_1.default.createElement(NewQualityForm_1.default, { handleNewQuality: handleNewQuality }))));
};
exports.default = PlantOptionsGrid;
